<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">Main Office Signatories for All Request Forms</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Form Signatories</p> 
    </div>
    <div class="">
        <select class="col-span-2 border-[#ACA9A9] border rounded-md py-3 text-sm text-[#12760A] font-semibold mt-3 w-full px-5" v-model="signatoryType">
            <option value="1" selected >LEAVE SIGNATORY</option>
            <option value="2" >CONSIDERATION SIGNATORY</option>
            <option value="3" >TRAINING REQUISTION SIGNATORY</option>
            <option value="4" >OVERTIME REQUEST SIGNATORY </option>
            <option value="5" >OFFICIAL BUSINESS REQUEST SIGNATORY</option>
        </select>
    </div>
    <div  class="flex flex-col gap-1 mt-3 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
        <div v-for="(division, index) in division" :key="index"  @click="test(division.division_code,division.division_description)">
            <div :class="{active: division.division_description === showDeparment}" class=" w-full border flex gap-5 text-left py-2 px-4 font-semibold rounded-md items-center justify-between hover:bg-[#e6e6e6]">
                <span :class="{spanactive: division.division_description === showDeparment}" class="flex justify-start text-sm text-[#606060]">{{ division.division_description }}</span>
                <div class="flex items-center gap-10">
                    <Dropdonwn :class="{'rotate-180': division.division_code == div_active }"/> 
                    <button class="bg-[#016B00] rounded-md py-2 px-11 text-xs text-white" @click="DivisionSignatory(division.division_code,division.division_description)">Signatory</button>
                </div>
            </div>
            <div v-show="showDeparment === division.division_description" class="bg-[#026b0046] rounded-md">
                <p class="text-xs px-4 pl-12 py-2 font-bold text-[#24723b]">DEPARTMENT</p>
                <div v-if="getDepartment == null" class="w-full border-[#e7e7e7] border-[1px] flex gap-5 text-left py-2 px-4  pl-[115px] font-semibold rounded-md items-center justify-between hover:bg-[#d4d4d4]">
                    <span class="flex justify-start text-xs text-[#7c7c7c]">Department not found</span>
                </div>
                <div v-if="getDepartment == null" class="bg-[#cdae1357] rounded-md" >
                        <p class="text-xs px-4 pl-[90px] py-2 font-bold text-[#24723b] ">SECTION</p>
                        <div v-if="gSection == null" class="w-full border-[#c9c9c9] border-[1px] flex gap-5 text-left py-2 px-4  pl-[115px] font-semibold rounded-md items-center justify-between hover:bg-[#d4d4d4]">
                            <span class="flex justify-start text-xs text-[#7c7c7c]">Section not found</span>
                        </div>
                        <div v-for="(section,index) in noDepartment" :key="index" class="">
                            <div v-if="section.section != null" class="w-full border-[#cdae1357] border-[1px] flex gap-5 text-left py-2 px-4  pl-[115px] font-semibold rounded-md items-center justify-between hover:bg-[#d4d4d4]" v-show="showDeparment === division.division_description">
                                <span class="flex justify-start text-xs text-[#7c7c7c]">{{ section.section }}</span>
                                <div class="flex items-center gap-10">
                                    <Dropdonwn/>
                                    <button class="bg-[#016B00] rounded-md py-2 px-11 text-xs text-white" @click="SectionSignatory(section.section_code,section.section)">Signatory</button>
                                </div>
                            </div>
                        </div>
                </div>
                <!-- DEPARTMENT -->
                <div v-for="(department,index) in getDepartment" :key="index">
                    <div  :class="{activeSection: department.department === showSection}" class="w-full border-[#026b0011] border-[1px] flex gap-5 text-left py-2 px-4 pl-[65px] font-semibold rounded-md items-center justify-between hover:bg-[#e6e6e6]" @click="getSection(department.department_code,department.department)">
                        <span :class="{spanactive: department.department === showSection}" class="flex justify-start text-xs text-[#7c7c7c]">{{ department.department }}</span>
                        <div class="flex items-center gap-10">
                            <Dropdonwn/>
                            <button class="bg-[#016B00] rounded-md py-2 px-11 text-xs text-white" @click="DepartmentSignatory(department.department_code,department.department)" >Signatory</button>
                        </div>
                    </div>
                    <!-- SHOW SECTION -->
                    <div class="bg-[#cdae1357] rounded-md" v-show="showSection === department.department">
                        <p class="text-xs px-4 pl-[90px] py-2 font-bold text-[#24723b] ">SECTION</p>
                        <div v-if="gSection == null" class="w-full border-[#c9c9c9] border-[1px] flex gap-5 text-left py-2 px-4  pl-[115px] font-semibold rounded-md items-center justify-between hover:bg-[#d4d4d4]">
                            <span class="flex justify-start text-xs text-[#7c7c7c]">Section not found</span>
                        </div>
                        <div v-for="(section,index) in gSection" :key="index" class="">
                            <div v-if="section.section != null" class="w-full border-[#cdae1357] border-[1px] flex gap-5 text-left py-2 px-4  pl-[115px] font-semibold rounded-md items-center justify-between hover:bg-[#d4d4d4]" v-show="showDeparment === division.division_description">
                                <span class="flex justify-start text-xs text-[#7c7c7c]">{{ section.section }}</span>
                                <div class="flex items-center gap-10">
                                    <Dropdonwn/>
                                    <button class="bg-[#016B00] rounded-md py-2 px-11 text-xs text-white" @click="SectionSignatory(section.section_code,section.section)">Signatory</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="SignatoryModal">
        <Signatory :signatoryType="signatoryType" @CloseSignatory="SignatoryModal= false" :signatoryTitle="signatoryTitle" :getName="GetName" :div_key="div_key" :dep_key="dep_key" :sec_key="sec_key"/>
    </div>
    
</template>

<script>
import { defineComponent } from "vue";
import Dropdonwn from "../../icons/DropdownSvg.vue"
import Signatory from "../../controls/modal/SignatoryModal.vue"

export default defineComponent({
    components:{
        Dropdonwn,
        Signatory
    },
    data(){
        return{
            division:           '',
            department:         '',
            getDepartment:      '',
            showDeparment:      '',
            showSection:        '',
            activeShow:         '',
            section:            '',
            gSection:           '',
            SignatoryModal:     false,
            signatoryTitle:     '',
            GetName:            '',

            divId:null,

            div_key:            null,
            dep_key:            null,
            sec_key:            null,

            noDepartment:   null,
            signatoryType:'1'
        }
    },
    mounted(){
       this.setLookUp()
    },
    methods:{
        classNames(div_active){
            this.div_key
            if(this.div_key == div_active){
                return 'rotate-180'
            }
        },
        setLookUp(){
            let that = this, state = this.$store.state

            that.division = state.divisionList 
            that.department =   state.departmentList 
            that.section =     state.sectionList
            that.GetName  =  state.emp_info 
        },
        test(test,div_name){
            let id = test

            this.div_active = test
            this.getDepartment = this.department.filter(test=>test.division_code == id)
            if(this.getDepartment.length === 0){
                this.getDepartment = null
            }

            this.noDepartment = this.section.filter(test=>test.division_code == id)
            this.showDeparment = div_name
        },
        getSection(test,dept_name){
            let id = test
            this.gSection = this.section.filter(test=>test.department_code == id)

            if(this.gSection.length === 0){
                this.gSection = null
            }
            this.showSection = dept_name

        },
        DivisionSignatory(divId,divName)
        {

            this.div_key = divId;
            this.dep_key = null;
            this.sec_key = null;

            this.SignatoryModal = true
            this.signatoryTitle = divName
        },
        DepartmentSignatory(depId,depName)
        {
            this.div_key = null;
            this.dep_key = depId;
            this.sec_key = null;

            this.SignatoryModal = true
            this.signatoryTitle = depName
        },
        SectionSignatory(secID,secName)
        {
            this.div_key = null;
            this.dep_key = null;
            this.sec_key = secID;

            this.SignatoryModal = true
            this.signatoryTitle = secName
        },
       
    }
})


</script>


<style scoped>
.active{
    background-color: #24723b;
    color: beige;
}

.activeSection{
    background-color: #CDAF13;
    color: beige;
}
.spanactive{
    color: white;
}
</style>